import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError, of } from 'rxjs';
import { articleSection } from 'constants/routes';


const getArticleSection$ = (payload) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      getArticleSectionCommand: payload
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  return fromFetch(articleSection, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError((error) => of(error))
  );
};

export default getArticleSection$;